/** Employment type. Stored lowercase; the staff export uppercases at render. */
export const STAFF_TYPES = ['permanent', 'contractual'];
export const STAFF_TYPE_LABELS = {
    permanent: 'Permanent',
    contractual: 'Contractual',
};
/**
 * How many timeline rows the task detail returns. A long-lived daily task
 * accumulates thousands; the drawer's Activity panel is a recent-history view,
 * not an archive.
 */
export const TASK_TIMELINE_LIMIT = 100;
/**
 * User/attendance fields a template variable may be bound to.
 *
 * Single source of truth for both the frontend Select and the backend resolver, so the
 * two cannot drift into offering a field that nothing fills in.
 */
export const WATI_FIELD_SOURCES = [
    'employee_name',
    'employee_code',
    'email',
    'phone',
    'department_name',
    'designation_name',
    'date_ist',
    'first_punch_in',
    'punch_count',
];
export const WATI_FIELD_SOURCE_LABEL = {
    employee_name: 'Employee name',
    employee_code: 'Employee code',
    email: 'Email',
    phone: 'Phone',
    department_name: 'Department',
    designation_name: 'Designation',
    date_ist: 'Date (today, IST)',
    first_punch_in: 'First punch-in time',
    punch_count: 'Punch count today',
};
/**
 * Which transport the nightly sweep uses.
 *
 * 'wati' is the official Business API (approved templates, positional parameters).
 * 'evolution' is a self-hosted Evolution API v2.3.7 running the Baileys driver, which has
 * no sendTemplate at all — it sends free text composed from `evolution.message_body`.
 * The two are therefore configured separately and only share the schedule.
 */
export const MESSAGE_PROVIDERS = ['wati', 'evolution'];
/**
 * Placeholder written literally into an Evolution message body. Free text has no
 * parameter list to map against, so the token IS the binding — the same nine field
 * sources WATI maps by name are resolved by substring replacement instead.
 */
export const EVOLUTION_TOKENS = WATI_FIELD_SOURCES.map((f) => `{{${f}}}`);
//# sourceMappingURL=types.js.map